module.exports = __webpack_public_path__ + "static/media/bg_img.7c6f29fd.jpg";